import { useMutation } from "@tanstack/react-query";
import { sendTracking } from "repositories/reservations/reservationRepository";

export const useSendTrackingMutation = () => {
  const isProduction = process.env.REACT_APP_VER === "production";
  return useMutation({ mutationFn: isProduction ? sendTracking : null });
};
